<template>
  <module-list-layout :createAction="createAction" :module="module" v-if="amReady">
    <el-dialog :visible.sync="dialogVisible" custom-class="el-custom-dialog" title="" top="5vh" width="82%">
      <moduleForm
          :autoBind="false"
          :bindingForView="true"
          :dataToBind="dataToBind"
          :edit-mode="editMode"
          :formHeader="true"
          :formTitle="((editMode)? 'Update ' : 'Create ') + module.info.caption"
          :moduleDeleteAction='moduleFormDeleteAction'
          :on-create-callback="afterCreate"
          :on-edit-callback="afterEdit"
          v-if="dialogVisible"></moduleForm>
    </el-dialog>

    <el-dialog :visible.sync="viewMatchedRatesDialog" custom-class="el-custom-dialog" title="Matched Rates" top="5vh" width="82%">
    </el-dialog>

    <el-row>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="[ {'label' : '(ALL)', value : ''}, ...$store.state['voip-vendor-api'].dropdownList ]"
            :translateLabel='false'
            :translateLabels="false"
            @amUpdated="supplierFilterUpdated"
            field_mark=""
            label="Suppliers"
            name="voip_supplier_id"
            placeholder=""></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="[ {'label' : '(ALL)', value : ''}, ...$store.state['voip-destination-api'].dropDownList ]"
            @amUpdated="destinationFilterUpdated"
            :translateLabel='false'
            :translateLabels="false"
            field_mark=""
            label="Destination"
            name="destination_id"
            placeholder=""></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="[ {'label' : '(ALL)', value : ''}, ...$store.state['voip-rate-division-api'].dropDownList ]"
            @amUpdated="divisionFilterUpdated"
            :translateLabel='false'
            :translateLabels="false"
            field_mark=""
            label="Division"
            name="division_id"
            placeholder=""></dg-select-field>
      </el-col>
    </el-row>

    <div class="row">
      <div class="col-12 col-md-6">
        <el-pagination
            :current-page.sync="currentPage"
            :hide-on-single-page="true"
            :page-size="pageChunkSize"
            :total="Math.ceil(recordsCounter / pageChunkSize)"
            @current-change="getEntityListData"
            @size-change="handleSizeChange"
            layout="total, prev, pager, next">
        </el-pagination>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>
import Vue from 'vue'
import {mapActions, mapState} from "vuex";
import module from './../../index.js'
import actionsCell from './ag-grid/ActionsCell'
import {notify} from '@/system-services/notify'
import smartAgGridWrapper from "@/components/smart-input-view/AgGridWrapper";

export default {
  components: {
    moduleForm: () => import('../../form/View'),
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  computed: {
    ...mapState(module.info.name + '-state', ['openedEntity', 'pageChunkSize', 'entities']),
  },
  data() {
    return {
      viewMatchedRatesDialog: false,
      selectedSupplier: '',
      selectedDivision: '',
      selectedDestination: '',
      editable : true,
      amReady: true,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      module: {...module},
      currentPage: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: (params) => {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'supplier_name',
            headerName: 'Supplier',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellClass: 'text-capitalize',
            width:110
          },
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            width:110
          },
          {
            field: 'division',
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            width:80
          },
          {
            headerName: 'Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellClass: 'text-capitalize',
            autoHeight: true,
            width:80,
            cellRendererFramework: Vue.extend(smartAgGridWrapper),
            cellRendererParams: {
              props: {
                inputWidth: '120px',
                fieldName: 'rate',
                saveAction: this.updateField,
                editContainerStyle: 'top: 0px;',
                noCopy: true,
                customParams: {}
              }
            },
            
            /*,cellRenderer: (params) => {
              return params.data.system_profit_percent  + '%';
            }*/
          },
          {
            field: 'note',
            headerName: 'Note',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            width:130
          },
          {
            field: 'created_by',
            headerName: 'Created By',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            width:80
          },
          {
            field: 'created_at',
            headerName: 'Created at',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            width:80
          },
          {
            width: 70,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.getFormData()
  },
  methods: {
    viewMatchedRates (params) {
      this.selectedTarget = params.data
      this.viewMatchedRatesDialog = true
    },
    supplierFilterUpdated (inputField) {
      let val = inputField.field.field_value
      this.selectedSupplier = val
      this.getEntityListData(1)
    },
    divisionFilterUpdated (inputField) {
      let val = inputField.field.field_value
      this.selectedDivision = val
      this.getEntityListData(1)
    },
    destinationFilterUpdated (inputField) {
      let val = inputField.field.field_value
      this.selectedDestination = val
      this.getEntityListData(1)
    },
    handleSizeChange(val) {
      console.log(`${val} items per page`);
    },
    handleCurrentChange(val) {
      console.log(`current page: ${val}`);
    },
    ...$mapActions('voip-vendor-api', {
      getSuppliersDropdown: 'getDropDownList',
    }),
    ...$mapActions('voip-destination-api', {
      getDestinationsDropDownList: 'getDropDownList',
    }),
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    getFormData() {
      this.getSuppliersDropdown().then((resp)=>{
        // let aa = $store.state['voip-vendor-api'].dropdownList
        // debugger
      })
      let promises = []
      promises.push(this.getDestinationsDropDownList())
      promises.push(this.getSuppliersDropdown())
      promises.push(this.getDivisionsDropDownList())
      promises.push(this.getEntityListData(this.currentPage))
      // this.currentPage = parseInt(this.$route.params.listPage)
      Promise.all(promises).then((values) => {
        this.amReady = true
        // Vue.nextTick(() => {
        //   this.bindController()
        // })
      })
    },
    ...mapActions(module.info.name + '-api', {
      getEntityList: 'list',
      updateEntity: 'update',
      multipleDelete: "multipleDelete"
    }),
    getSelectedRowData() {
      let selectedNodes = this.agGrid.gridApi.getSelectedNodes();
      let selectedData = selectedNodes.map(node => node.data.id);
      this.multipleDelete({data: {ids: selectedData}}).then(r => {
        this.getEntityListData(1)
      })
    },
    updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.data.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    getEntityListData(page) {
      this.getEntityList({
        page: page,
        division: this.selectedDivision,
        destination: this.selectedDestination,
        supplier: this.selectedSupplier
      }).then(response => {
        
        this.buildAgGridData(response)
        this.currentPage = page
      })
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    navigateToPage(page, onLoaded = false) {
      this.getEntityListData(page, onLoaded)
    },
    refreshGrid(onLoaded = false) {
      this.navigateToPage(this.currentPage, onLoaded)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.agGrid.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.agGrid.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
